/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    JsonPartyInfo,
    JsonPartyInfoFromJSON,
    JsonPartyInfoFromJSONTyped,
    JsonPartyInfoToJSON,
} from './JsonPartyInfo';

/**
 * 
 * @export
 * @interface ApiResultOfListOfJsonPartyInfo
 */
export interface ApiResultOfListOfJsonPartyInfo {
    /**
     * 
     * @type {Array<JsonPartyInfo>}
     * @memberof ApiResultOfListOfJsonPartyInfo
     */
    data?: Array<JsonPartyInfo>;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfListOfJsonPartyInfo
     */
    message?: string;
    /**
     * 
     * @type {object}
     * @memberof ApiResultOfListOfJsonPartyInfo
     */
    messageValues?: object;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfListOfJsonPartyInfo
     */
    requestId?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfListOfJsonPartyInfo
     */
    result?: ApiResultOfListOfJsonPartyInfoResultEnum;
}

/**
* @export
* @enum {string}
*/
export enum ApiResultOfListOfJsonPartyInfoResultEnum {
    Ok = 'OK',
    Error = 'ERROR'
}

export function ApiResultOfListOfJsonPartyInfoFromJSON(json: any): ApiResultOfListOfJsonPartyInfo {
    return ApiResultOfListOfJsonPartyInfoFromJSONTyped(json, false);
}

export function ApiResultOfListOfJsonPartyInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiResultOfListOfJsonPartyInfo {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : ((json['data'] as Array<any>).map(JsonPartyInfoFromJSON)),
        'message': !exists(json, 'message') ? undefined : json['message'],
        'messageValues': !exists(json, 'messageValues') ? undefined : json['messageValues'],
        'requestId': !exists(json, 'requestId') ? undefined : json['requestId'],
        'result': !exists(json, 'result') ? undefined : json['result'],
    };
}

export function ApiResultOfListOfJsonPartyInfoToJSON(value?: ApiResultOfListOfJsonPartyInfo | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data === undefined ? undefined : ((value.data as Array<any>).map(JsonPartyInfoToJSON)),
        'message': value.message,
        'messageValues': value.messageValues,
        'requestId': value.requestId,
        'result': value.result,
    };
}

